module.exports = __webpack_public_path__ + "static/media/8.94599e08.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row1/8.wav
// module id = 36
// module chunks = 0